import IntegrationToken from '@apps/finance/admin/tokens/integration'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    integration: PropTypes.string,
    revenue_type: PropTypes.object
  }

  state = {
    type: null
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { revenue_type } = this.props
    return {
      title: 't(Edit Revenue Type)',
      method: 'PATCH',
      endpoint: `/api/admin/finance/revenue_types/${revenue_type.id}`,
      action: `/api/admin/finance/revenue_types/${revenue_type.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Title)', name: 'title', type: 'textfield', required: true },
            { label: 't(Description)', name: 'description', type: 'textarea' }
          ]
        },
        ...this._getIntegration()
      ]
    }
  }

  _getIntegration() {
    const { integration } = this.props
    if(!integration) return []
    return [{
      label: <IntegrationToken integration={ integration } />,
      padded: false,
      fields: [
        { label: 't(Revenue Code)', name: 'integration.revenue_code', type: 'textfield', required: true },
        { label: 't(Source Code)', name: 'integration.source_code', type: 'textfield' }
      ]
    }]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Edit
